import {UserGroupEnum} from "../../UserGroupModel/constants/UserGroupEnum";
import {MemberStatusEnum} from "../constants/MemberStatusEnum";

export class MemberAutocompleteView {
    id: number;
    companyName: string;
    userGroupId: UserGroupEnum;
    status: MemberStatusEnum;
    expertRoleId: number;

    constructor(data?: any) {
        this.id = data?.id ?? 0;
        this.companyName = data?.companyName ?? "";
        this.userGroupId = data?.userGroupId ?? 0;
        this.status = data?.status ?? 0;
        this.expertRoleId = data?.expertRoleId ?? 0;
    }
}